/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
type Props = { isDrawer?: boolean }

const ChatInner: FC<Props> = ({ isDrawer = false }) => {
  return (<div></div>)
}

export { ChatInner }
